import * as Yup from "yup";
export const PASSWORD_REGEX_ERROR_MESSAGE = "Password must have at least 8 signs, one small letter, one large letter and one digit.";
export const passwordRegex = Yup.string().matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/, PASSWORD_REGEX_ERROR_MESSAGE);
